import React, { useEffect, useState } from 'react';
import { TimerIcon } from 'lucide-react';
const START_SECONDS = 17 * 60 + 34;
function pad(value: number) {
  return value.toString().padStart(2, '0');
}
type CountdownProps = {
  tone?: 'light' | 'dark';
};
export function Countdown({
  tone = 'light'
}: CountdownProps) {
  const [remaining, setRemaining] = useState(START_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? START_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const isDark = tone === 'dark';
  const unitBox = isDark ? 'bg-navy-900 text-white ring-1 ring-white/15' : 'bg-navy-900 text-white';
  const units = [{
    value: pad(hours),
    label: 'ore'
  }, {
    value: pad(minutes),
    label: 'min'
  }, {
    value: pad(seconds),
    label: 'sec'
  }];
  return <div className="flex flex-col items-center gap-2" data-id="element-93" data-mp="y0wrfchtfgg9">
      <p className={`flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-[0.14em] ${isDark ? 'text-gold-300' : 'text-navy-700'}`} data-id="element-94" data-mp="xzc1k06g4loq">
        <TimerIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-95" data-mp="17pokjnym46sr" />
        L’offerta scade tra
      </p>
      <div className="flex items-start gap-1.5" role="timer" aria-live="off" aria-label={`Offerta valida ancora ${minutes} minuti e ${seconds} secondi`} data-id="element-96" data-mp="12sevwaj1rz5z">
        {units.map((unit, i) => <React.Fragment key={unit.label} data-id="element-97" data-mp="a5kclgxyv5u3" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-98" data-mp="o38vij8h42wi">
              <span className={`min-w-[54px] rounded-lg px-2 py-1.5 text-center text-2xl font-black tabular-nums sm:text-3xl ${unitBox}`} data-id="element-99" data-mp="o0nw00vndz1x">
                {unit.value}
              </span>
              <span className={`mt-1 text-[10px] font-bold uppercase tracking-[0.16em] ${isDark ? 'text-white/60' : 'text-navy-800/60'}`} data-id="element-100" data-mp="1vgu5ghjetp9x">
                {unit.label}
              </span>
            </div>
            {i < units.length - 1 && <span className={`pt-1 text-2xl font-black sm:text-3xl ${isDark ? 'text-white/40' : 'text-navy-900/30'}`} aria-hidden="true" data-id="element-101" data-mp="123kqhcqup2yg">
                :
              </span>}
          </React.Fragment>)}
      </div>
    </div>;
}